<template>
  <div class="top">
    <header>
      <Header/>
    </header>
    <main>
      <Background/>
    </main>
    <footer class="footer_position">
      <div class="footer__color"></div>    
    </footer>
  </div>
</template>

<script>
import Header from '../components/common/Header.vue'
import Background from '../components/top/Background.vue'

export default {
  name: 'top',
  components: {
    Header,
    Background,
  }
}
</script>
<style lang="scss" scoped>
.top {
  position: fixed;
  background: #000000;
  height: 100%;
  width: 100vw;
}
// .footer__color {
//   position: absolute;
//   bottom: 0;
//   height: 4vw;
//   min-height: 45px;
//   width: 100vw;
//   background: #000000;
// }
</style>